<script>import { filterAttrs } from "../helpers";
import { setAttrs } from "../helpers";
export let attributes = undefined;
export let maxWidth = undefined;
function stringifyStyles(stylesObj) {
    let styles = "";
    for (let key in stylesObj) {
        const dashedKey = key.replace(/[A-Z]/g, function (match) {
            return "-" + match.toLowerCase();
        });
        styles += dashedKey + ":" + stylesObj[key] + ";";
    }
    return styles;
}
</script>

<section
  style={stringifyStyles({
    width: "100%",
    alignSelf: "stretch",
    flexGrow: 1,
    boxSizing: "border-box",
    maxWidth: maxWidth || 1200,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    marginLeft: "auto",
    marginRight: "auto",
  })}
  {...filterAttrs(attributes, "on:", false)}
  use:setAttrs={filterAttrs(attributes, "on:", true)}
>
  <slot />
</section>